import React from 'react';
import { Link } from 'react-router-dom';
import { Building, User, Server, Scale, ArrowLeft } from 'lucide-react';

const LegalNotice = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      {/* Header */}
      <div className="bg-[#1A1A1A] text-white py-16">
        <div className="max-w-4xl mx-auto px-4">
          <Link to="/" className="inline-flex items-center gap-2 text-[#C9A227] hover:text-white transition-colors mb-6">
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
          <h1 className="font-serif text-4xl md:text-5xl mb-4">Mentions Légales</h1>
          <p className="text-gray-400">Informations légales relatives au site www.excelsium.online</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="space-y-12">
          
          {/* Éditeur */}
          <section className="bg-white p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <Building className="w-6 h-6 text-[#C9A227]" />
              <h2 className="font-serif text-2xl text-[#1A1A1A]">Éditeur du Site</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6 text-gray-600">
              <div>
                <p className="font-medium text-[#1A1A1A] mb-1">Raison sociale</p>
                <p>Excelsium Conseils</p>
              </div>
              <div>
                <p className="font-medium text-[#1A1A1A] mb-1">Forme juridique</p>
                <p>SARL</p>
              </div>
              <div>
                <p className="font-medium text-[#1A1A1A] mb-1">Siège social</p>
                <p>Pacha Centre, Montplaisir<br />Tunis, Tunisie</p>
              </div>
              <div>
                <p className="font-medium text-[#1A1A1A] mb-1">Contact</p>
                <p>Téléphone : +216 96 050 699<br />Email : direction@excelsium.online</p>
              </div>
            </div>
          </section>

          {/* Directeur de publication */}
          <section className="bg-white p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <User className="w-6 h-6 text-[#C9A227]" />
              <h2 className="font-serif text-2xl text-[#1A1A1A]">Directeur de la Publication</h2>
            </div>
            <p className="text-gray-600">
              Le directeur de la publication du site www.excelsium.online est le représentant légal de la société Excelsium Conseils.
            </p>
          </section>

          {/* Hébergement */}
          <section className="bg-white p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <Server className="w-6 h-6 text-[#C9A227]" />
              <h2 className="font-serif text-2xl text-[#1A1A1A]">Hébergement</h2>
            </div>
            <div className="text-gray-600">
              <p className="mb-2">Le site www.excelsium.online est hébergé par :</p>
              <p className="font-medium text-[#1A1A1A]">Emergent Labs Inc.</p>
              <p>Service d'hébergement cloud sécurisé</p>
              <p>Site web : https://emergent.sh</p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section className="bg-white p-8 border border-gray-200">
            <div className="flex items-center gap-3 mb-6">
              <Scale className="w-6 h-6 text-[#C9A227]" />
              <h2 className="font-serif text-2xl text-[#1A1A1A]">Propriété Intellectuelle</h2>
            </div>
            <div className="text-gray-600 space-y-4">
              <p>
                L'ensemble du contenu de ce site (textes, images, logos, éléments graphiques, icônes) est la propriété 
                exclusive d'Excelsium Conseils ou de ses partenaires, et est protégé par les lois françaises et 
                internationales relatives à la propriété intellectuelle.
              </p>
              <p>
                Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des 
                éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation 
                écrite préalable d'Excelsium Conseils.
              </p>
              <p>
                Toute exploitation non autorisée du site ou de son contenu sera considérée comme constitutive d'une 
                contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de 
                la Propriété Intellectuelle.
              </p>
            </div>
          </section>

          {/* Limitation de responsabilité */}
          <section className="bg-white p-8 border border-gray-200">
            <h2 className="font-serif text-2xl text-[#1A1A1A] mb-6">Limitation de Responsabilité</h2>
            <div className="text-gray-600 space-y-4">
              <p>
                Excelsium Conseils s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations 
                diffusées sur ce site. Toutefois, Excelsium Conseils ne peut garantir l'exactitude, la précision 
                ou l'exhaustivité des informations mises à disposition sur ce site.
              </p>
              <p>
                En conséquence, Excelsium Conseils décline toute responsabilité pour toute imprécision, inexactitude 
                ou omission portant sur des informations disponibles sur ce site, ainsi que pour tous dommages 
                résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations 
                mises à disposition sur le site.
              </p>
            </div>
          </section>

          {/* Droit applicable */}
          <section className="bg-[#1A1A1A] text-white p-8 rounded-lg">
            <h2 className="font-serif text-2xl mb-4">Droit Applicable</h2>
            <p className="text-gray-300">
              Les présentes mentions légales sont régies par le droit tunisien et français. En cas de litige, 
              les tribunaux tunisiens seront seuls compétents.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
